
import { defineComponent } from "vue";
import { useMainStore } from "@/stores";
import { sec2time, sec2worldTime } from "@/helpers/time";
import { definitions } from "@/types/EcoWebServer";

type ServerInfo = definitions["Eco.Shared.Networking.ServerInfo"];
type ServerInfoRuntime = ServerInfo & {
  DaysRunning?: number;
  DaysUntilMeteor?: number;
};

export default defineComponent({
  setup() {
    const store = useMainStore();

    return { store };
  },
  computed: {
    runtimeServerInfo(): ServerInfoRuntime {
      return this.serverInfo as ServerInfoRuntime;
    },
    hasServerInfo(): boolean {
      return this.runtimeServerInfo.DaysRunning != null || this.serverInfo?.TimeSinceStart != null;
    },
    serverInfo(): ServerInfo {
      return this.store.serverInfo;
    },
    time(): string {
      const daysRunning = this.runtimeServerInfo.DaysRunning;
      if (daysRunning != null) return sec2worldTime(daysRunning * 24 * 60 * 60);
      const timeSinceStart = this.serverInfo?.TimeSinceStart;
      if (timeSinceStart == null) return "";
      return sec2worldTime(timeSinceStart);
    },
    meteorImpact(): string {
      const daysUntilMeteor = this.runtimeServerInfo.DaysUntilMeteor;
      const untilImpact = daysUntilMeteor == null
        ? this.serverInfo?.TimeLeft ?? 0
        : daysUntilMeteor * 24 * 60 * 60;
      if (untilImpact <= 0) {
        if (!this.serverInfo.HasMeteor) return this.$t("No Meteor");
        else return this.$t("The meteor was destroyed");
      } else return sec2time(untilImpact);
    },
  },
});
